<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "filter" });
export let css = "";
export let isScaling = true;
</script>

<svg xmlns = 'http://www.w3.org/2000/svg'
    fill = 'none'
    viewBox = '0 0 22 20'
    on:mouseenter
    on:mouseleave
    on:keypress
    on:click
    class = { `s8-icon ${ css }` }
    stroke = '#272711'
>
    <!-- eslint-disable max-len -->
        <path
            d = 'M2.38589 3.66687C1.62955 2.82155 1.25138 2.39889 1.23712 2.03968C1.22473 1.72764 1.35882 1.42772 1.59963 1.22889C1.87684 1 2.44399 1 3.57828 1H18.4212C19.5555 1 20.1227 1 20.3999 1.22889C20.6407 1.42772 20.7748 1.72764 20.7624 2.03968C20.7481 2.39889 20.3699 2.82155 19.6136 3.66687L13.9074 10.0444C13.7566 10.2129 13.6812 10.2972 13.6275 10.3931C13.5798 10.4781 13.5448 10.5697 13.5236 10.6648C13.4997 10.7721 13.4997 10.8852 13.4997 11.1113V16.4584C13.4997 16.6539 13.4997 16.7517 13.4682 16.8363C13.4403 16.911 13.395 16.9779 13.336 17.0315C13.2692 17.0922 13.1784 17.1285 12.9969 17.2012L9.59686 18.5612C9.22931 18.7082 9.04554 18.7817 8.89802 18.751C8.76901 18.7242 8.6558 18.6476 8.583 18.5377C8.49975 18.4122 8.49975 18.2142 8.49975 17.8184V11.1113C8.49975 10.8852 8.49975 10.7721 8.47587 10.6648C8.45469 10.5697 8.41971 10.4781 8.37204 10.3931C8.31828 10.2972 8.2429 10.2129 8.09213 10.0444L2.38589 3.66687Z'
            stroke-width = '1.5'
            stroke-linecap = 'round'
            stroke-linejoin = 'round'
            vector-effect = { isScaling ? 'none' : 'non-scaling-stroke' }>
        </path>
    <!-- eslint-enable -->
</svg>